import React from 'react';

const Partnerships = () => {
  const partnerships = [
    {
      name: 'boolala',
      logo: '/images/partners/partner1.png', // Update with actual logo path
      url: 'https://boolala.com.au', // Replace with actual partner website URL
      description: 'Leading manufacturer of premium joinery.'
    },
    {
      name: 'luxia',
      logo: '/images/partners/partner2.png', // Update with actual logo path
      url: 'https://luxia.au', // Replace with actual partner website URL
      description: 'Specialized in custom timber flooring.'
    },
    {
      name: 'Partner 3',
      logo: '/images/partners/partner3.png', // Update with actual logo path
      url: '#', // Replace with actual partner website URL
      description: 'Expert in aluminium doors and windows.'
    },
    {
      name: 'Partner 4',
      logo: '/images/partners/partner4.png', // Update with actual logo path
      url: '#', // Replace with actual partner website URL
      description: 'Trusted provider of bathroom products.'
    }
  ];

  return (
    <section id="partnerships" className="py-16 sm:py-24 bg-premium-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block mb-4">
            <span className="text-premium-gold text-sm font-semibold tracking-widest uppercase">Our Partnerships</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Trusted Partners<br />Excellence Together
          </h2>
          <p className="text-base sm:text-xl text-gray-400 max-w-3xl mx-auto">
            We collaborate with industry leaders to deliver exceptional solutions and unmatched quality
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {partnerships.map((partner, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center space-y-4"
            >
              <div className="h-20 sm:h-24 flex items-center justify-center">
                <a
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={partner.name}
                  className="inline-flex"
                >
                  <img
                    src={partner.logo}
                    alt={`${partner.name} logo`}
                    className="max-h-full max-w-full object-contain filter invert"
                  />
                </a>
              </div>
              <p className="text-sm sm:text-base text-gray-400 leading-relaxed max-w-xs">
                {partner.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partnerships;
